(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "babel-runtime/helpers/toConsumableArray"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("babel-runtime/helpers/toConsumableArray"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.toConsumableArray);
    global.array = mod.exports;
  }
})(this, function (exports, _toConsumableArray2) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.flatten = flatten;

  var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Flattens an array.
   * @param {Array} arr The array to flatten.
   * @returns {Array} The flattened array.
   * @memberof util
   * @private
   * @since 1.0.0
   */
  function flatten(arr) {
    return arr.reduce(function (flat, val) {
      return Array.isArray(val) ? flat.concat(val) : [].concat((0, _toConsumableArray3.default)(flat), [val]);
    }, []);
  }
});